import { useState } from "react";
import { CalendarDays } from "lucide-react";

const PRESETS = [
  ["today", "Today", 0], ["7d", "7 days", 6], ["30d", "30 days", 29], ["90d", "90 days", 89], ["365d", "12 months", 364],
];
const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const rangeFromDates = (from, to) => ({
  start: new Date(`${from}T00:00:00`).toISOString(),
  end: new Date(`${to}T23:59:59.999`).toISOString(),
  from, to,
});

export const presetRange = (days) => {
  const to = new Date();
  const from = new Date();
  from.setDate(to.getDate() - days);
  return rangeFromDates(ymd(from), ymd(to));
};

export const DEFAULT_RANGE = { key: "30d", ...presetRange(29) };

const dateCls = "bg-slate-950 border border-slate-800 rounded-full px-3 py-1.5 text-sm font-mono text-slate-200 [color-scheme:dark] focus:outline-none focus:border-emerald-500";

export const DateFilter = ({ value, onChange }) => {
  const [from, setFrom] = useState(value.from);
  const [to, setTo] = useState(value.to);
  const setCustom = (f, t) => {
    setFrom(f); setTo(t);
    if (f && t && f <= t) onChange({ key: "custom", ...rangeFromDates(f, t) });
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="date-filter">
      <div className="inline-flex flex-wrap rounded-full border border-slate-800 bg-slate-950 p-1">
        {PRESETS.map(([k, label, days]) => (
          <button key={k} data-testid={`date-preset-${k}`}
            onClick={() => { const r = presetRange(days); setFrom(r.from); setTo(r.to); onChange({ key: k, ...r }); }}
            className={`px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors ${
              value.key === k ? "bg-emerald-500 text-slate-950" : "text-slate-400 hover:text-white"}`}>
            {label}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <CalendarDays className={`w-4 h-4 ${value.key === "custom" ? "text-emerald-400" : "text-slate-500"}`} />
        <input type="date" data-testid="date-from-input" value={from} max={to} onChange={(e) => setCustom(e.target.value, to)} className={dateCls} />
        <span className="text-slate-500 text-sm">to</span>
        <input type="date" data-testid="date-to-input" value={to} min={from} onChange={(e) => setCustom(from, e.target.value)} className={dateCls} />
      </div>
    </div>
  );
};
